export enum AdvancedFiltersType {
  AdminAf = "AdminAf",
  ProjectUsersAf = "ProjectUsersAf",
}
